import { backButtonNextToBreadcrumb } from "../../../setup/settings/__product";
import BackArrowIcon from "../../../setup/assets/BackArrowIcon";

export function BackButton() {

    const prevUrl = () => {
        let prevUrl = document.referrer;
        if (prevUrl.indexOf(window.location.host) !== -1) {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = '/';
            }
        } else {
            window.location.href = '/';
        }
    }

    return (
        <div className="product-back-button">
            <a className="back-to-list-button" onClick={prevUrl}>
                <span className="back-to-list-icon-arrow">
                    <BackArrowIcon />
                </span>
                {backButtonNextToBreadcrumb.text}
            </a>
        </div>
    );
}
